/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ThreatResponse extends models.ThreatVulnerabilityBaseResponse {
    getFixupPrototypeFunction() { return ThreatResponse.fixupPrototype; }

    static newInstance(model: Partial<ThreatResponse>): ThreatResponse {
        let obj = Object.assign(new ThreatResponse(), model);
        ThreatResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ThreatResponse>): ThreatResponse {
        if (!model) return null;
        return ThreatResponse.newInstance(<ThreatResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ThreatResponse) {
        if (!obj) return;

        models.ThreatResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ThreatResponse): boolean {
        if (models.ThreatVulnerabilityBaseResponse.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ThreatResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * List of threat intents, representing the potential goals or purposes behind the threat, such as \"Persistence\", \"CredentialAccess\", or \"DefenseEvasion\". These help categorize and understand the threat behavior.
     */
    intent: Array<string>;

    /**
     * Unique identifier of the threat.
     */
    threat_id: string;

    /**
     * ITSM ticket number raised for this threat. Empty when no ticket exists.
     */
    ticket_id: string;

    /**
     * Deep link to the ITSM ticket in the customer's ITSM tool. Empty when no ticket exists.
     */
    ticket_url: string;

}
